import { useEffect, useState } from "react";

import { ReactComponent as ArrowUpIcon } from "../icons/FaqUpArrow.svg";

const GoToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return visible ? (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="w-[48px] h-[48px] bg-text-1000 rounded-[100px] text-primaryDark-0 hover:text-primaryDark-400 transition-all fixed bottom-[20px] md:bottom-[40px] right-[20px] md:right-[40px] z-[100] flex items-center justify-center shadow-md shadow-text-0/24"
    >
      <ArrowUpIcon className="w-[24px] h-[24px]" />
    </button>
  ) : null;
};

export default GoToTopButton;
